<template>
  <div>
    <v-row v-if="fichePreparation.laverie" no-gutters>
      <v-col cols="6">
        <v-text-field
                v-model="fichePreparation.preparedFor"
                label="Préparer pour"
                type="date"
                @blur="onBlur"
              />
      </v-col>
      <v-divider vertical class="mx-4"></v-divider>
      <v-col cols="3">
        <br />
        Choisissez la date
      </v-col>
    </v-row>
    <v-row v-if="fichePreparation.preparedFor" no-gutters>
      <v-col cols="6">
        <v-select
          v-model="fichePreparation.preparedBy"
          :items="users"
          item-title="fullName"
          return-object
          label="Préparé par"
          @update:model-value="onChange"
        ></v-select>
      </v-col>
      <v-divider vertical class="mx-4"></v-divider>
      <v-col cols="3">
        <br />
        Choisissez le préparateur
      </v-col>
    </v-row>
    <v-row
      v-if="
        fichePreparation.preparedBy && fichePreparation.preparedBy.lastname == 'personne'
      "
      no-gutters
    >
      <v-col cols="6">
        <v-text-field
          name="autreUserLastname"
          v-model="fichePreparation.preparedBy.name"
          
          label="Précisez"
          @blur="onBlur"
        >
        </v-text-field>
      </v-col>
      <v-divider vertical class="mx-4"></v-divider>
      <v-col cols="3"> </v-col>
    </v-row>
    <v-row
      v-if="fichePreparation.preparedBy && fichePreparation.preparedBy.lastname"
      no-gutters
    >
      <v-col cols="6">
        <v-select
          v-model="fichePreparation.deliveredBy"
          :items="users"
          item-title="fullName"
          return-object
          label="Livraison par"
          @update:model-value="onChange"
        ></v-select>
      </v-col>
      <v-divider vertical class="mx-4"></v-divider>
      <v-col cols="3">
        <br />
        Choisissez le livreur
      </v-col>
    </v-row>
    <v-row
      v-if="
        fichePreparation.deliveredBy &&
        fichePreparation.deliveredBy.lastname == 'personne'
      "
      no-gutters
    >
      <v-col cols="6">
        <v-text-field
          name="autreUserLastname1"
          v-model="fichePreparation.deliveredBy.name"
          
          label="Précisez"
          @blur="onBlur"
        >
        </v-text-field>
      </v-col>
      <v-divider vertical class="mx-4"></v-divider>
      <v-col cols="3"> </v-col>
    </v-row>
    <v-card-actions>
      <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
      <generate-doc-btn
        :filePath="fichePreparationTemplatePath"
        :fileName="fichePreparationFileName"
        :dataSet="fichePreparationGen"
        >Save</generate-doc-btn
      >
    </v-card-actions>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { FichePreparation } from "@/types";
import { FichePreparationGen } from "@/types";
import { flattenFichePreparation } from "@/types";
import type { Laverie } from "@/types";
import type { User } from "@/types";

// Props
interface Props {
  laverie: Laverie;
  users: User[];
}

const props = defineProps<Props>();
const fichePreparation = ref<FichePreparation>({
  laverie: props.laverie,
} as FichePreparation);
const fichePreparationGen = ref<FichePreparationGen>(new FichePreparationGen());

// Computed properties
const fichePreparationTemplatePath = computed(() => {
  return "templates/FichePreparationTemplate.docx";
});

const fichePreparationFileName = computed(() => {
  if (fichePreparation.value.laverie) {
    return "FicheDePreparation_".concat(fichePreparation.value.laverie.name);
  }
  return "FicheDePreparation";
});

// Watch for prop changes
watch(
  () => props.laverie,
  (newLaverie) => {
    fichePreparation.value.laverie = newLaverie;
    onBlur();
  }
);

// Methods
const onChange = () => {
  onBlur();
};

const onBlur = () => {
  fichePreparationGen.value = flattenFichePreparation(fichePreparation.value);
};

const onCancel = () => {
  // Clear the form
  fichePreparation.value = {
    laverie: props.laverie,
  } as FichePreparation;
  fichePreparationGen.value = {} as FichePreparationGen;
};
</script>
